(function () {
  if (window.__quickAddInit) return;
  window.__quickAddInit = true;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var container = drawer.querySelector('.cart__items');
    if (container) {
      var rowsHtml = cart.items.map(function (item) {
        var img = item.image || '';
        if (img.indexOf('//') === 0) img = 'https:' + img;
        return (
          '<div class="cart__item" data-key="' + item.key + '" style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #eee;">' +
            '<a href="' + item.url + '" style="flex-shrink:0;">' +
              '<img src="' + img + '" alt="' + item.product_title + '" width="80" style="border-radius:4px;">' +
            '</a>' +
            '<div style="flex:1;">' +
              '<a href="' + item.url + '" style="font-weight:600;text-decoration:none;color:inherit;">' + item.product_title + '</a>' +
              '<div style="display:flex;align-items:center;gap:8px;margin-top:8px;">' +
                '<button type="button" class="qty-decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" style="width:26px;height:26px;border:1px solid #ccc;background:#fff;cursor:pointer;">-</button>' +
                '<span style="min-width:20px;text-align:center;">' + item.quantity + '</span>' +
                '<button type="button" class="qty-increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" style="width:26px;height:26px;border:1px solid #ccc;background:#fff;cursor:pointer;">+</button>' +
                '<button type="button" class="qty-remove" data-key="' + item.key + '" style="margin-left:10px;background:none;border:none;text-decoration:underline;cursor:pointer;color:#888;font-size:12px;">Remove</button>' +
              '</div>' +
              '<div style="margin-top:6px;">' + money(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      container.innerHTML = rowsHtml || '<p style="padding:20px;">Your cart is empty.</p>';
      container.setAttribute('data-count', cart.item_count);
    }

    drawer.querySelectorAll('[class*="subtotal" i]').forEach(function (el) {
      if (/\$[\d,]+\.\d{2}/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\$[\d,]+\.\d{2}/, money(cart.total_price));
      }
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('is-open') || drawer.classList.contains('drawer--is-open');
    if (wasOpen) {
      drawer.classList.add('is-open', 'drawer--is-open');
    } else {
      var cartBtn = document.querySelector('.js-drawer-open-cart');
      if (cartBtn) {
        drawer.style.pointerEvents = 'none';
        cartBtn.click();
        setTimeout(function () { drawer.style.pointerEvents = ''; }, 600);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest ? e.target.closest('.quick-add-btn') : null;
    if (addBtn && addBtn.tagName !== 'A') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      var qty = parseInt(addBtn.getAttribute('data-qty'), 10) || 0;
      addBtn.textContent = 'Adding...';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (result) {
          if (result && result.status) throw new Error(result.description || 'Add to cart failed');
          qty += 1;
          addBtn.setAttribute('data-qty', qty);
          addBtn.textContent = '\u2713 Added (' + qty + ')';
          addBtn.classList.add('quick-add-btn--added');
          addBtn.disabled = false;
          clearTimeout(addBtn._resetTimer);
          addBtn._resetTimer = setTimeout(function () {
            addBtn.textContent = '+ Add to cart';
            addBtn.classList.remove('quick-add-btn--added');
          }, 3000);
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function (err) {
          console.log('Quick add error:', err);
          addBtn.textContent = '+ Add to cart';
          addBtn.disabled = false;
        });
      return;
    }

    var qtyBtn = e.target.closest ? e.target.closest('.qty-increase, .qty-decrease, .qty-remove') : null;
    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var key = qtyBtn.getAttribute('data-key');
      var newQty = qtyBtn.classList.contains('qty-remove') ? 0 : parseInt(qtyBtn.getAttribute('data-qty'), 10);
      if (newQty < 0) newQty = 0;
      qtyBtn.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function (err) {
          console.log('Quantity update error:', err);
          qtyBtn.disabled = false;
        });
    }
  }, true);
})();